var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 4.48665C12.28 4.26665 10.0467 4.15332 7.82 4.15332C6.5 4.15332 5.18 4.21999 3.86 4.35332L2.5 4.48665",
    stroke: "#E90500",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16699 3.81301L6.31366 2.93967C6.42033 2.30634 6.50033 1.83301 7.62699 1.83301H9.37366C10.5003 1.83301 10.587 2.33301 10.687 2.94634L10.8337 3.81301",
    stroke: "#E90500",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0669 6.59375L12.6336 13.3071C12.5603 14.3537 12.5003 15.1671 10.6403 15.1671H6.36026C4.50026 15.1671 4.44026 14.3537 4.36693 13.3071L3.93359 6.59375",
    stroke: "#E90500",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38672 11.5H9.60672",
    stroke: "#E90500",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83301 8.83301H10.1663",
    stroke: "#E90500",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.1552a0eff98426b4c3b3c6cb16f53b3c.svg";
export { ForwardRef as ReactComponent };